"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantSepaDirectDebitAuthorisationResultToJSON = exports.GrantSepaDirectDebitAuthorisationResultFromJSONTyped = exports.GrantSepaDirectDebitAuthorisationResultFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function GrantSepaDirectDebitAuthorisationResultFromJSON(json) {
    return GrantSepaDirectDebitAuthorisationResultFromJSONTyped(json, false);
}
exports.GrantSepaDirectDebitAuthorisationResultFromJSON = GrantSepaDirectDebitAuthorisationResultFromJSON;
function GrantSepaDirectDebitAuthorisationResultFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customer': !(0, runtime_1.exists)(json, 'customer') ? undefined : (0, _1.CustomerDataFromJSON)(json['customer']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
        'downloadUrl': !(0, runtime_1.exists)(json, 'downloadUrl') ? undefined : json['downloadUrl'],
    };
}
exports.GrantSepaDirectDebitAuthorisationResultFromJSONTyped = GrantSepaDirectDebitAuthorisationResultFromJSONTyped;
function GrantSepaDirectDebitAuthorisationResultToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customer': (0, _1.CustomerDataToJSON)(value.customer),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
        'downloadUrl': value.downloadUrl,
    };
}
exports.GrantSepaDirectDebitAuthorisationResultToJSON = GrantSepaDirectDebitAuthorisationResultToJSON;
//# sourceMappingURL=GrantSepaDirectDebitAuthorisationResult.js.map